import { useRef, useReducer, useEffect } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var $$t = /*#__PURE__*/Symbol("$$t");
var A;

(function (A) {
  var Get;

  (function (Get) {
  })(Get = A.Get || (A.Get = {}));

  A.test = function (_o) {};

  A.areEqual = function (_debug) {
    return undefined;
  };
})(A || (A = {}));

var R = {
  get: function get(r, k) {
    return r[k];
  },
  concat: function concat(r1, r2) {
    return _extends({}, r1, r2);
  },
  fromMaybe: function fromMaybe(r) {
    return r != null ? r : {};
  },
  keys: function keys(r) {
    return Object.keys(r);
  }
};
var useConstant = function useConstant(compute) {
  var ref = useRef(null);
  if (ref.current === null) ref.current = compute();
  return ref.current;
};
var assertNever = function assertNever(_value) {
  throw new Error("Invariant: assertNever was called");
};

var useStateMachineImpl = function useStateMachineImpl(definition) {
  var _useReducer = useReducer(createReducer(definition), createInitialState(definition)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var send = useConstant(function () {
    return function (sendable) {
      return dispatch({
        type: "SEND",
        sendable: sendable
      });
    };
  });

  var setContext = function setContext(updater) {
    dispatch({
      type: "SET_CONTEXT",
      updater: updater
    });
    return {
      send: send
    };
  };

  useEffect(function () {
    var entry = R.get(definition.states, state.value).effect;
    var exit = entry == null ? void 0 : entry({
      send: send,
      setContext: setContext,
      event: state.event,
      context: state.context
    });
    return typeof exit === "function" ? function () {
      return exit == null ? void 0 : exit({
        send: send,
        setContext: setContext,
        event: state.event,
        context: state.context
      });
    } : undefined; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.value, state.event]);
  return [state, send];
};

var createInitialState = function createInitialState(definition) {
  var nextEvents = R.keys(R.concat(R.fromMaybe(R.get(definition.states, definition.initial).on), R.fromMaybe(definition.on)));
  return {
    value: definition.initial,
    context: definition.context,
    event: {
      type: "$$initial"
    },
    nextEvents: nextEvents,
    nextEventsT: nextEvents
  };
};

var createReducer = function createReducer(definition) {
  var log = createLogger(definition);
  return function (machineState, internalEvent) {
    if (internalEvent.type === "SET_CONTEXT") {
      var nextContext = internalEvent.updater(machineState.context);
      log("Context update", ["Previous Context", machineState.context], ["Next Context", nextContext]);
      return _extends({}, machineState, {
        context: nextContext
      });
    }

    if (internalEvent.type === "SEND") {
      var _R$get;

      var sendable = internalEvent.sendable;
      var event = typeof sendable === "string" ? {
        type: sendable
      } : sendable;
      var context = machineState.context;
      var stateNode = R.get(definition.states, machineState.value);
      var resolvedTransition = (_R$get = R.get(R.fromMaybe(stateNode.on), event.type)) != null ? _R$get : R.get(R.fromMaybe(definition.on), event.type);

      if (!resolvedTransition) {
        log("Current state doesn't listen to event type \"" + event.type + "\".", ["Current State", machineState], ["Event", event]);
        return machineState;
      }

      var _ref = function () {
        if (typeof resolvedTransition === "string") return [resolvedTransition];
        if (resolvedTransition.guard === undefined) return [resolvedTransition.target];
        if (resolvedTransition.guard({
          context: context,
          event: event
        })) return [resolvedTransition.target];
        return [resolvedTransition.target, true];
      }(),
          nextStateValue = _ref[0],
          _ref$ = _ref[1],
          didGuardDeny = _ref$ === void 0 ? false : _ref$;

      if (didGuardDeny) {
        log("Transition from \"" + machineState.value + "\" to \"" + nextStateValue + "\" denied by guard", ["Event", event], ["Context", context]);
        return machineState;
      }

      log("Transition from \"" + machineState.value + "\" to \"" + nextStateValue + "\"", ["Event", event]);
      var resolvedStateNode = R.get(definition.states, nextStateValue);
      var nextEvents = R.keys(R.concat(R.fromMaybe(resolvedStateNode.on), R.fromMaybe(definition.on)));
      return {
        value: nextStateValue,
        context: context,
        event: event,
        nextEvents: nextEvents,
        nextEventsT: nextEvents
      };
    }

    return assertNever();
  };
}; // test sub-typing


var defaultConsole = console;

var createLogger = function createLogger(definition) {
  return function (groupLabel) {
    if (!definition.verbose) return;
    var console = definition.console || defaultConsole;

    if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test") {
      console.groupCollapsed == null ? void 0 : console.groupCollapsed("%cuseStateMachine", "color: #888; font-weight: lighter;", groupLabel);

      for (var _len = arguments.length, nested = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        nested[_key - 1] = arguments[_key];
      }

      nested.forEach(function (message) {
        console.log(message[0], message[1]);
      });
      console.groupEnd == null ? void 0 : console.groupEnd();
    }
  };
};

var useStateMachine = useStateMachineImpl;
var t = function t() {
  var _ref2;

  return _ref2 = {}, _ref2[$$t] = undefined, _ref2;
};

export default useStateMachine;
export { t };
//# sourceMappingURL=usestatemachine.esm.js.map
